import React from 'react';
import styled from 'styled-components';
import { UploadingFileItem } from './uploading-file-item.component';
import { useDeleteConfirmation } from '../../../hooks/use-delete-confirmation.hook';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "uploading-file-listcomponent__Container",
  componentId: "sc-dsbsw4-0"
})(["display:flex;flex-direction:column;gap:12px;"]);
var ListHeader = styled.div.withConfig({
  displayName: "uploading-file-listcomponent__ListHeader",
  componentId: "sc-dsbsw4-1"
})(["font-size:12px;font-weight:700;color:#8b95b0;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:4px;"]);
var ListContent = styled.div.withConfig({
  displayName: "uploading-file-listcomponent__ListContent",
  componentId: "sc-dsbsw4-2"
})(["display:flex;flex-direction:column;gap:8px;max-height:240px;overflow-y:auto;padding-right:4px;&::-webkit-scrollbar{width:4px;}&::-webkit-scrollbar-track{background:transparent;}&::-webkit-scrollbar-thumb{background:#e0e4ef;border-radius:4px;}"]);
export var UploadingFileList = function UploadingFileList(_ref) {
  var files = _ref.files,
      onRemove = _ref.onRemove;

  var _useDeleteConfirmatio = useDeleteConfirmation({
    itemType: 'file'
  }),
      confirmDelete = _useDeleteConfirmatio.confirmDelete;

  var handleRemove = function handleRemove(file) {
    confirmDelete(function () {
      onRemove(file);
    });
  };

  if (!files.length) return null;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(ListHeader, {
      children: ["UPLOADED FILES (", files.length, ")"]
    }), /*#__PURE__*/_jsx(ListContent, {
      children: files.map(function (_ref2, index) {
        var file = _ref2.file;
        return /*#__PURE__*/_jsx(UploadingFileItem, {
          file: file,
          onRemove: function onRemove() {
            return handleRemove(file);
          }
        }, index);
      })
    })]
  });
};